import React from "react";
import VantaBackground from "../components/VantaBackground";
import Navbar from "../components/Navbar";
import "../styles/products.css";
import { useNavigate } from "react-router-dom";

// Import images
import DefenzaImage from "../assets/Defenza.webp";
import DeepfakeImage from "../assets/deepfake.webp";

const products = [
  {
    id: 1,
    name: "Defenza",
    description:
      "An AI-powered chat app with real-time threat detection and a secure browser, ensuring safe online interactions.",
    image: DefenzaImage,
  },
  {
    id: 2,
    name: "Deepfake Detection",
    description:
      "A cutting-edge tool capable of detecting deepfakes in real-time and via uploaded media, enhancing digital security.",
    image: DeepfakeImage,
  },
];

const ProductPage = () => {
  const navigate = useNavigate();

  return (
    <div className="product-page">
      <VantaBackground />
      <Navbar />
      <div className="hero-container">
        <h1 className="hero-heading">Innovate with EncryptArx</h1>
        <p className="hero-subheading">
          Empowering breakthroughs in technology and reshaping the future. Join us as we redefine innovation.
        </p>
      </div>
      <div className="product-cards-container">
        {products.map(({ id, name, description, image }) => (
          <div
            className="card"
            key={id}
            style={{ backgroundImage: `url(${image})` }}
          >
            <div className="card-content">
              <h3 className="card-title">{name}</h3>
              <p className="card-body">{description}</p>
              <button
                className="learn-more-button"
                onClick={() => navigate(`/product/${id}`)}
              >
                Learn More
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="animated-box">
        <h2 className="animated-box-heading">
          <span className="rd-heading">Research &amp; Development</span>
        </h2>
        <div className="animated-box-content">
          <p className="animated-box-text">
            Innovation at EncryptArx starts with our dedicated{" "}
            <span className="highlight">Research</span> and{" "}
            <span className="highlight">Development</span> (R&D) wing, where an idea develops into a technology that changes the form of things.
            With a deep commitment to transforming the digital frontier, in alliance with{" "}
            <span className="highlight">Kanu Analytics</span> we established Defenza—a next-gen AI-powered chat application with advanced threat detection and safe browsing.
            The Defenza project is also one that has been enhanced by in-house development—a avant-garde{" "}
            <span className="highlight">Deepfake Detection Tool</span>, which seeks only to enhance digital security and fight misinformation in the age of AI.
          </p>
          <p className="animated-box-text">
            But this is just the beginning. Our{" "}
            <span className="highlight">R&amp;D team</span> is forever on the lookout for uncharted territory and setting it up for the future.
            The range includes everything from advanced AI-driven predictive analytics tools to next-generation cybersecurity solutions tailored for businesses and individuals alike.
            Our mission: to deliver{" "}
            <span className="highlight">cutting-edge innovations</span> that will empower a safer, smarter, more connected world.
          </p>
        </div>
      </div>
      <div className="collaborative-box">
        <h1 className="collab-title">Join Forces with Innovators</h1>
        <p className="collab-description">
          At EncryptArx, we believe in the power of collaboration to push boundaries and redefine possibilities.
          Whether you're a visionary entrepreneur, a cutting-edge developer, or a forward-thinking organization, let's create groundbreaking solutions together.
          The future is built by those who dare to innovate—let's shape it as one.
        </p>
        <button className="collab-button">COLLABORATE NOW</button>
      </div>
    </div>
  );
};

export default ProductPage;
